// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./firewallApi";

export let rootFwApi = new Api();
